import {
  createDocFlow,
  DOC_FLOW_FORM_FIELD_CONNECTED_REQUESTS,
  useCreateDocFlow,
} from '../../../DocFlow'
import { toRequestSelectItems } from '../../Request.utils'

export function useRequestCreateDocFlow({
  onCloseModal,
  onReload,
  onSetModal,
}) {
  const { handleOpenCreation } = useCreateDocFlow({
    setModal: onSetModal,
    onClose: onCloseModal,
    onReload,
    onSubmit: createDocFlow,
  })

  function handleOpenDocFlowCreation(requests) {
    handleOpenCreation({
      [DOC_FLOW_FORM_FIELD_CONNECTED_REQUESTS]: toRequestSelectItems(requests),
    })
  }

  return { handleOpenDocFlowCreation }
}
